export default __webpack_public_path__ + "static/media/0500e3a91d128b5dfb0e1f4806b97023.svg";